<template>
  <div>
    <Loader v-if="isLoading" display="absolute"></Loader>
    <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs" />

    <chart-doughnut-legend-card
      v-if="type === 'doughnut'"
      :chart-data="chartData"></chart-doughnut-legend-card>

    <percentage-bars
      v-if="type === 'percentageBars'"
      :chart-data="chartData"></percentage-bars>

    <bar-chart-legend-card
      v-if="type === 'bar'"
      :chart-data="chartData"></bar-chart-legend-card>

    <line-chart-card
      v-if="type === 'line' || type === 'multiline'"
      :filters-data="filtersData"
      :active-filter="activeFilterId"
      :chart-data="chartData"
      :from-label="fromLabel"
      :to-label="toLabel"
      :date-from="dateFrom"
      :datefto="dateTo"
      :re-init-pickers="reInitPickers"
      :type="type"
      :graph-update-counter="graphUpdateCounter"
      @changed-duration="getNewSelectedFilter"
      @changed-date="getDates"></line-chart-card>
  </div>
</template>

<script>
import axios from 'axios'
import Loader from '../components/common/Loader.vue'
import Alert from '../components/common/Alert.vue'
import ChartDoughnutLegendCard from '../components/charts/Chart-doughnut-legend-card.vue'
import PercentageBars from '../components/charts/Percentage-bars.vue'
import BarChartLegendCard from '../components/charts/Bar-chart-legend-card.vue'
import LineChartCard from '../components/charts/Line-chart-card.vue'

export default {
  components: {
    Loader,
    Alert,
    BarChartLegendCard,
    ChartDoughnutLegendCard,
    PercentageBars,
    LineChartCard,
  },
  emits: ['changed-date'],
  data() {
    return {
      isLoading: false,
      errorMsgs: [],
      chartData: [],
      type: '',
      filtersData: {},
      activeFilterId: '',
      dates: null,
      reInitPickers: false,
      graphUpdateCounter: 0,
    }
  },

  mounted() {
    if (this.handler && this.filterHandler === '') {
      this.fetchData()
    }

    if (this.filterHandler) {
      this.fetchFilters()
    }
  },

  methods: {
    fetchData() {
      this.isLoading = true

      axios
        .post(this.handler, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
        .then((response) => {
          const { hasError, errorMessages, data, type } = response.data

          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          this.isLoading = false
          this.chartData = data
          this.type = type
        })
        .catch((errors) => {
          console.error(errors)
        })
    },

    fetchFilters() {
      this.isLoading = true
      axios
        .post(this.filterHandler, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
        .then((response) => {
          const { hasError, errorMessages, data } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          this.isLoading = false
          this.filtersData = data

          console.log('  this.filtersData',   this.filtersData)

          if (this.filtersData) {
            this.activeFilterId = this.filtersData.filters.find(
              (filter) => filter.isSelected
            ).id

            this.fetchLineData()
          }
        })
        .catch((errors) => {
          console.error(errors)
        })
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },

    fetchLineData() {
      this.isLoading = true

      const postData = {
        selectedFilter: this.activeFilterId,
        mutualfundcode: this.mutualFundCode,
        shareClassCode: this.shareClassCode,
        dates: this.dates,
      }

      axios
        .post(this.handler, postData)
        .then((response) => {
          const { hasError, errorMessages, data, type } = response.data

          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          this.isLoading = false
          this.chartData = data
          this.type = type
          this.graphUpdateCounter++
        })
        .catch((errors) => {
          console.error(errors)
        })
    },

    getNewSelectedFilter(activeId) {
      this.activeFilterId = activeId
      if (this.dates) {
        this.dates = null

        this.reInitPickers = true
      }
      this.fetchLineData()
    },

    getDates(dates) {
      this.dates = dates
      this.activeFilterId = ''

      this.fetchLineData()
      this.$emit('changed-date', dates)
    },
  },
}
</script>
